import { durationToEnglish } from '@/utils/dateTime'

export default function(duration) {
  return durationToEnglish(duration)
}
